import type { ThemeDefinition } from "vuetify";

export const staticPrimaryColor = "#254EA2";
export const staticPrimaryDarkenColor = "#1B376E";
export const staticDarkModeBlue = "#002866";
export const staticDarkModeSurfaceBlue = "#063272";

export const themes: Record<string, ThemeDefinition> = {
  light: {
    dark: false,
    colors: {
      primary: staticPrimaryColor,
      "on-primary": "#FFFFFF",
      "primary-darken-1": staticPrimaryDarkenColor,

      secondary: "#f990bd",
      "secondary-darken-1": "#DE79A8",
      "on-secondary": "#1B376E",

      success: "#2EAD73",
      "success-darken-1": "#268E5F",
      "on-success": "#FFFFFF",
      "success-toast": "#EAF3FF",
      "on-success-toast": "#254EA2",

      info: "#16B1FF",
      "info-darken-1": "#149FE6",
      "on-info": "#FFFFFF",

      warning: "#FFB400",
      "warning-darken-1": "#E6A200",
      "on-warning": "#FFFFFF",

      error: "#D94F72",
      "error-darken-1": "#BF3E61",
      "on-error": "#FFFFFF",

      background: "#FFFFFF",
      "on-background": "#1B376E",

      surface: "#FFFFFF",
      "on-surface": "#1B376E",

      "grey-50": "#FAFAFA",
      "grey-100": "#F5F5F5",
      "grey-200": "#EEEEEE",
      "grey-300": "#E0E0E0",
      "grey-400": "#BDBDBD",
      "grey-500": "#9E9E9E",
      "grey-600": "#757575",
      "grey-700": "#616161",
      "grey-800": "#424242",
      "grey-900": "#212121",

      "perfect-scrollbar-thumb": "#D4DCEC",
      "skin-bordered-background": "#FFFFFF",
      "skin-bordered-surface": "#FFFFFF",
      "expansion-panel-text-custom-bg": "#FDF3FA",
      "track-bg": "#EAF0FF",
      "chat-bg": "#FDF3FA",
    },

    variables: {
      "code-color": "#F190BA",
      "overlay-scrim-background": "#254EA2",
      "tooltip-background": "#1B376E",
      "overlay-scrim-opacity": 0.5,
      "hover-opacity": 0.04,
      "focus-opacity": 0.1,
      "selected-opacity": 0.08,
      "activated-opacity": 0.16,
      "pressed-opacity": 0.14,
      "dragged-opacity": 0.1,
      "disabled-opacity": 0.4,
      "border-color": "#254EA2",
      "border-opacity": 0.12,
      "table-header-color": "#FFFFFF",
      "high-emphasis-opacity": 0.9,
      "medium-emphasis-opacity": 0.7,

      // 👉 shadows
      "shadow-key-umbra-color": "#254EA2",
      "shadow-xs-opacity": "0.12",
      "shadow-sm-opacity": "0.14",
      "shadow-md-opacity": "0.16",
      "shadow-lg-opacity": "0.18",
      "shadow-xl-opacity": "0.20",
    },
  },

  dark: {
    dark: true,
    colors: {
      primary: "#F190BA",
      "on-primary": "#1B376E",
      "primary-darken-1": "#DE79A8",

      secondary: "#F7B7D1",
      "secondary-darken-1": "#F190BA",
      "on-secondary": "#1B376E",

      success: "#6DD99A",
      "success-darken-1": "#46BE7B",
      "on-success": "#FFFFFF",
      "success-toast": "#DCE9FF",
      "on-success-toast": "#1B376E",

      info: "#16B1FF",
      "info-darken-1": "#149FE6",
      "on-info": "#FFFFFF",

      warning: "#FFB400",
      "warning-darken-1": "#E6A200",
      "on-warning": "#FFFFFF",

      error: "#F07898",
      "error-darken-1": "#D94F72",
      "on-error": "#FFFFFF",

      background: staticDarkModeBlue,
      "on-background": "#FFFFFF",

      surface: staticDarkModeSurfaceBlue,
      "on-surface": "#FFFFFF",

      "grey-50": staticDarkModeBlue,
      "grey-100": staticDarkModeSurfaceBlue,
      "grey-200": "#0D3D84",
      "grey-300": "#285996",
      "grey-400": "#4C76AD",
      "grey-500": "#8AA4D6",
      "grey-600": "#AFC0E3",
      "grey-700": "#CFDAF0",
      "grey-800": "#EAF0FF",
      "grey-900": "#F7F9FF",

      "perfect-scrollbar-thumb": "#4C76AD",
      "skin-bordered-background": staticDarkModeBlue,
      "skin-bordered-surface": staticDarkModeSurfaceBlue,
      "expansion-panel-text-custom-bg": "#0D3D84",
      "track-bg": "#0D3D84",
      "chat-bg": "#052D6D",
    },

    variables: {
      "code-color": "#F7B7D1",
      "overlay-scrim-background": staticDarkModeBlue,
      "tooltip-background": "#FDF3FA",
      "overlay-scrim-opacity": 0.5,
      "hover-opacity": 0.04,
      "focus-opacity": 0.1,
      "selected-opacity": 0.08,
      "activated-opacity": 0.16,
      "pressed-opacity": 0.14,
      "disabled-opacity": 0.4,
      "dragged-opacity": 0.1,
      "border-color": "#FFFFFF",
      "border-opacity": 0.12,
      "table-header-color": "#0D3D84",
      "high-emphasis-opacity": 0.9,
      "medium-emphasis-opacity": 0.7,

      // 👉 Shadows
      "shadow-key-umbra-color": "#001A42",
      "shadow-xs-opacity": "0.20",
      "shadow-sm-opacity": "0.22",
      "shadow-md-opacity": "0.24",
      "shadow-lg-opacity": "0.26",
      "shadow-xl-opacity": "0.28",
    },
  },
};

export default themes;
